// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.feature-details {
    display: flex;
    flex-direction: column;
    height: 100%;
}

/* tabs: a grid of buttons separated by white lines, every row is filled completely */
.feature-details div.ButtonBar {
    display: flex;
    flex-wrap: wrap;
    gap: 2px;
    padding: 2px 0;
    margin: 0;
    border: 0;
    background-color: #fff;
}
.feature-details div.ButtonBar div.buttonbar-button-container {
    flex: 1 1 auto;
    display: flex;
    border: 0;
    margin: 0;
}
.feature-details div.ButtonBar div.buttonbar-button-container > button.button {
    flex: 1 1 auto;
    border: 0;
    border-radius: 0;
    padding: 0.7em 1em;
    white-space: nowrap;
    background-color: #d3d6d5;
    color: #323232;
    transition: background-color 0.15s;
}
.feature-details div.ButtonBar button span {
    padding: 0;
    margin: 0;
}
.feature-details div.ButtonBar button.button:not(:disabled):not(.pressed):hover {
    background-color: #bfc3c2;
}
.feature-details div.ButtonBar button.button.pressed:not(:disabled) {
    background-color: #078aa3;
    color: white;
    font-weight: bold;
    box-shadow: inset 0 -3px 0 #05566a;
}

.feature-link {
    cursor: pointer;
    color: #337ab7;
}

.feature-details {
    font-size: .9em;
}
.feature-details-tabs {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
}
.feature-details-tab {
    padding: 0.5em;
    flex-grow: 1;
}
.feature-details-tab .attribute-list {
    width: 100%;
    border-collapse: collapse;
}
.feature-details-tab .attribute-list td {
    vertical-align: top;
    border-bottom: 1px solid #e6e9e8;
    padding: .35rem .5rem;
}
.feature-details-tab .attribute-list tr:last-child td {
    border-bottom: 0;
}
.feature-details-tab .attribute-list td:first-child {
    padding-right: 1rem;
    color: #6b7070;
    white-space: nowrap;
}
.feature-details-tab .attribute-list tr:hover td {
    background-color: #e6f1f3;
}

.feature-details-ajax > div {
    text-align: center;
}
.feature-details-ajax .spinner {
    text-align: center;
    margin: 0 auto;
    width: 50px;
    height: 50px;
}

/* breadcrumb */
.feature-breadcrumb {
    padding: .4em .75em;
    margin: 0;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    background-color: #eceeee;
    border-bottom: 1px solid #d3d6d5;
}
.feature-breadcrumb li {
    margin: 0 .35em 0 0;
    padding: 0;
    list-style-type: none;
    font-size: .85rem;
    color: #323232;
}
.feature-breadcrumb li:last-child {
    font-weight: bold;
}
.feature-breadcrumb  .icon {
    font-size: .65rem;
    color: #8a8f8e;
    margin-right: .1em;
}
.feature-breadcrumb li:first-child .icon {
    display: none;
}
.feature-breadcrumb li .link {
    cursor: pointer;
    color: #078aa3;
}
.feature-breadcrumb li .link:hover {
    text-decoration: underline;
    color: #05566a;
}

/* ajax table */
.feature-ajax-table {
    width: 100%;
    border-collapse: collapse;
}
.feature-ajax-table .actions .icon {
    cursor: pointer;
    color: #078aa3;
}
.feature-ajax-table .actions .icon:hover {
    color: #05566a;
}
.feature-ajax-table .interactive:hover {
    background-color: #eeeeee;
}
.feature-ajax-table .actions span {
    margin-left: 6px;
}
.feature-ajax-table thead th {
    color: #323232;
    text-align: left;
    font-weight: bold;
    padding: 6px 8px;
    background-color: #eceeee;
    border-bottom: 2px solid #afb3b2;
    position: sticky;
    top: 0;
}
.feature-ajax-table tbody tr:nth-child(even) {
    background-color: #f2f4f4;
}
.feature-ajax-table tbody tr:hover {
    background-color: #dcecef;
}
.feature-ajax-table tbody tr:hover td {
    border-color: #fff;
}
.feature-ajax-table tbody td {
    padding: 5px 8px;
}
.feature-ajax-table tbody td {
    border-right: 1px solid #dcdfde;
}
.feature-ajax-table tbody td:last-child {
    border-right: 0;
}
.feature-ajax-table .actions {
    white-space: nowrap;
}

/* download */
.feature-details-ajax-download {
    text-align: right;
}

/* image */
.feature-details-image img {
    width: 100%;
}
.feature-details-image-options {
    padding: 5px 10px 10px;
    display: flex;
    flex-wrap: wrap;
}
.feature-details-image-options label {
    display: inline-block;
    margin-right: 15px;
    margin-bottom: 3px;
}
.feature-details-image-options input {
    margin-right: 5px;
}

/* ajax gallery */
.feature-details-ajaxgallery-images {
    display: flex;
    align-items: stretch;
    justify-content: left;
    flex-wrap: wrap;
}
.feature-details-ajaxgallery-images > div {
    text-align: center;
    border: 1px solid #bbb;
    margin-right: 10px;
    margin-bottom: 10px;
}

/* ajax slider */
.feature-details-ajaxslider {
    text-align: center;
}
.feature-details-ajaxslider-image {
    border: 1px solid #bbb;
    padding: 5px;
}
.feature-details-ajaxslider-nav {
    display: flex;
    align-items: center;
    gap: .5rem;
    margin-top: .5rem;
    justify-content: space-between;
}
.feature-details-ajaxslider-nav .nav-imgs {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: .5rem
}
.feature-details-ajaxslider-nav .nav-imgs > * {
    flex-basis: 120px;
    flex-shrink: 1;
}
.feature-details-ajaxslider-nav img {
    width: 100%;
}
.feature-details-ajaxslider-nav .caption {
    word-break: break-all;
    font-size: 11px;
}
.feature-details-ajaxslider-nav .nav-img {
    padding: 5px;
    border: 1px solid #bbb;
    cursor: pointer;
}
.feature-details-ajaxslider-nav .nav-left {
    padding: 5px;
    border: 1px solid #bbb;
    cursor: pointer;
}
.feature-details-ajaxslider-nav .nav-left i {
    font-size: 20px;
    vertical-align: middle;
}
.feature-details-ajaxslider-nav .nav-right {
    padding: 5px;
    border: 1px solid #bbb;
    cursor: pointer;
}
.feature-details-ajaxslider-nav .nav-right i {
    font-size: 20px;
    vertical-align: middle;
}

/* linklist */
.feature-details-linklist table span {
    cursor: pointer;
    text-decoration: underline;
}
.feature-details-linklist table {
    width: 100%;
}
.feature-details-linklist table img {
    cursor: pointer;
    max-width: 100%;
}
.feature-details-linklist table td:last-child {
    text-align: right;
}

/* form */
.feature-details-field {
    display: block;
    margin-bottom: 10px;
}
.feature-details-input {
    border: 1px solid #bbb;
    display: flex;
    margin-right: 1em;
}
.feature-details-addon {
    border-left: 1px solid #bbb;
    padding: .3em;
}
.feature-details-field input[type="text"], .feature-details-field input[type="date"], .feature-details-field input[type="number"] {
    box-sizing: border-box;
    width: 100%;
    display: block;
    border: 0;
    background-color: transparent;
}
.feature-details-field select {
    box-sizing: border-box;
    width: 100%;
    display: block;
    border: 0;
    background-color: transparent;
    padding: .3em;
}
/* The frame is drawn by the wrapper only. qwc2's default input style (border, background, height) has a higher
   specificity than the rules above and would add a second border to every text field. */
div.feature-details-field div.feature-details-input {
    background-color: var(--input-bg-color);
    border-radius: var(--border-radius);
}
div.feature-details-field div.feature-details-input input:not([type="checkbox"]):not([type="radio"]):not([type="range"]):not([type="file"]),
div.feature-details-field div.feature-details-input textarea {
    border: 0;
    border-radius: 0;
    box-sizing: border-box;
    width: 100%;
}
div.feature-details-field div.feature-details-input select {
    height: 2em;
}
/* the geometry row only holds a button, no input frame */
div.feature-details-field div.feature-details-input.feature-details-geometry {
    background-color: transparent;
}
.feature-details-field label {
    display: block;
    opacity: .8;
    font-size: .85em;
    margin-bottom: 2px;
}
.feature-details-required-marker {
    color: #c00;
}
.feature-details-geometry {
    display: flex;
    align-items: center;
    gap: .6em;
    flex-wrap: wrap;
    border: 0 !important;
}
.feature-details-geometry-status {
    color: #c00;
    font-size: .85em;
}
.feature-details-geometry-hint {
    font-size: .85em;
    opacity: .8;
}
.feature-details-autocomplete {
    width: 100%;
}
.feature-details-autocomplete-selected {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: .3em;
    box-sizing: border-box;
}
.feature-details-autocomplete-search {
    position: relative;
    width: 100%;
}
.feature-details-autocomplete-search input[type="text"] {
    box-sizing: border-box;
    width: 100%;
    display: block;
    border: 0;
    background-color: transparent;
    padding: .3em;
}
.feature-details-autocomplete-results {
    position: absolute;
    z-index: 10;
    left: 0;
    right: 0;
    margin: 0;
    padding: 0;
    list-style: none;
    background: #fff;
    border: 1px solid #bbb;
    max-height: 12em;
    overflow-y: auto;
}
.feature-details-autocomplete-results li {
    padding: .3em;
    cursor: pointer;
}
.feature-details-autocomplete-results li:hover {
    background-color: #eee;
}
/* === Upload  === */
.feature-details-documents-upload-progresses {
    display: flex;
    flex-direction: column; /* stack items vertically */
    gap: 8px;               /* space between upload items */
    width: 100%;
    box-sizing: border-box;
}

/* Individual Upload */
.feature-details-documents-upload-progress {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    box-sizing: border-box;
    margin-bottom: 8px;
    font-family: inherit;
}

.feature-details-documents-upload-progress > div:first-child {
    font-weight: 600;
    margin-bottom: 4px;
    word-break: break-all; /* handle long filenames */
}

/* Progress container */
.feature-details-documents-upload-progress-bar {
    width: 100%;
    background-color: #eee;
    border-radius: 3px;
    height: 8px;
    position: relative;
    overflow: hidden;
    box-sizing: border-box;
}

/* Progress fill */
.feature-details-documents-upload-progress-fill {
    height: 100%;
    background-color: #5cb85c;
    border-radius: 3px;
    transition: width 0.2s ease;
    width: 0; /* default safe value */
}

/* Error state */
.feature-details-documents-upload-progress-fill.error {
    background-color: #d9534f;
}

/* Error text */
.feature-details-documents-upload-error {
    color: red;
    font-weight: 600;
    margin-top: 4px;
    font-size: 0.9em;
    word-break: break-word;
}

/* Ajax table overflow (scrollable to the right if needed) */
.feature-details-fileupload .feature-details-ajax > div {
    overflow-x: scroll;
    max-width: 100%;
}

/* Drag hover visual feedback */
.feature-details-fileupload {
    transition-property: background-color, background-color, filter;
    transition-duration: .2s;
    transition-timing-function: ease;
    padding: 1em;
    min-height: 100%; /* make sure drag-n-drop area fits the full window. */
}
.feature-details-fileupload.drag-hover {
    /* outline instead of border to keep size stable */
    outline: 2px dashed #4caf50;
    outline-offset: -2px;
    background-color: rgba(76, 175, 80, 0.3);
}
.feature-details-fileupload .upload-drop-area {
    border: 2px dashed #ccc;
    border-radius: 6px;
    padding: 20px;
    text-align: center;
    color: #666;
    margin-bottom: 1em;

    cursor: pointer;
    transition-property: transform, color, border-color, background-color, filter;
    transition-duration: .2s;
    transition-timing-function: ease;
}
.feature-details-fileupload.drag-hover .upload-drop-area {
    color: #4caf50;
    border-color: #4caf50;
    background: white;
}

.feature-details-fileupload .feature-details-input {
    padding: 0;
}



.display-none {
    display: none;
}


/* pois */
.feature-details-poi {
    margin-bottom: 1rem;
}
.feature-details-poi h5 {
    margin: .3rem 0 .5rem;
    font-size: 1rem;
}
.feature-details-poi .poi-item {
    display: flex;
    align-items: center;
    justify-content: left;
}
.feature-details-poi .poi-item img {
    margin-right: 5px;
}
.feature-details-poi .poi-item span {
    margin-right: 5px;
}
.feature-details-poi .poi-item strong {
    margin-left: auto;
}
.feature-details-poi .poi-item:nth-child(odd) {
    background-color: #eee;
}

/* add components */
.feature-details-component-add input {
    display: block;
    padding: .5em !important;
    width: 100%;
}
.feature-details-component-add ul {
    margin: 0;
    padding: 0;
}
.feature-details-component-add li {
    margin: .3rem 0 0 0;
    padding: .5rem;
    background-color: #eee;
    cursor: pointer;
}

.feature-details-component-attachments div div {
    display: flex;
    align-items: center;
    gap: 5px;
}

/* */
.feature-details-component-subs div.mt-3 {
    margin-top: 2rem;
}
`, "",{"version":3,"sources":["webpack://./js/style/FeatureDetails.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA,qFAAqF;AACrF;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,cAAc;IACd,SAAS;IACT,SAAS;IACT,sBAAsB;AAC1B;AACA;IACI,cAAc;IACd,aAAa;IACb,SAAS;IACT,SAAS;AACb;AACA;IACI,cAAc;IACd,SAAS;IACT,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,kCAAkC;AACtC;AACA;IACI,UAAU;IACV,SAAS;AACb;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,kCAAkC;AACtC;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;AACA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,cAAc;IACd,YAAY;AAChB;AACA;IACI,WAAW;IACX,yBAAyB;AAC7B;AACA;IACI,mBAAmB;IACnB,gCAAgC;IAChC,qBAAqB;AACzB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,cAAc;IACd,mBAAmB;AACvB;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,YAAY;AAChB;;AAEA,eAAe;AACf;IACI,mBAAmB;IACnB,SAAS;IACT,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,yBAAyB;IACzB,gCAAgC;AACpC;AACA;IACI,mBAAmB;IACnB,UAAU;IACV,qBAAqB;IACrB,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;IACjB,cAAc;IACd,kBAAkB;AACtB;AACA;IACI,aAAa;AACjB;AACA;IACI,eAAe;IACf,cAAc;AAClB;AACA;IACI,0BAA0B;IAC1B,cAAc;AAClB;;AAEA,eAAe;AACf;IACI,WAAW;IACX,yBAAyB;AAC7B;AACA;IACI,eAAe;IACf,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,gCAAgC;IAChC,gBAAgB;IAChB,MAAM;AACV;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,kBAAkB;AACtB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,+BAA+B;AACnC;AACA;IACI,eAAe;AACnB;AACA;IACI,mBAAmB;AACvB;;AAEA,aAAa;AACb;IACI,iBAAiB;AACrB;;AAEA,UAAU;AACV;IACI,WAAW;AACf;AACA;IACI,sBAAsB;IACtB,aAAa;IACb,eAAe;AACnB;AACA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,iBAAiB;AACrB;;AAEA,iBAAiB;AACjB;IACI,aAAa;IACb,oBAAoB;IACpB,qBAAqB;IACrB,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA,gBAAgB;AAChB;IACI,kBAAkB;AACtB;AACA;IACI,sBAAsB;IACtB,YAAY;AAChB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,iBAAiB;IACjB,8BAA8B;AAClC;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B;AACJ;AACA;IACI,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI,WAAW;AACf;AACA;IACI,qBAAqB;IACrB,eAAe;AACnB;AACA;IACI,YAAY;IACZ,sBAAsB;IACtB,eAAe;AACnB;AACA;IACI,YAAY;IACZ,sBAAsB;IACtB,eAAe;AACnB;AACA;IACI,eAAe;IACf,sBAAsB;AAC1B;AACA;IACI,YAAY;IACZ,sBAAsB;IACtB,eAAe;AACnB;AACA;IACI,eAAe;IACf,sBAAsB;AAC1B;;AAEA,aAAa;AACb;IACI,eAAe;IACf,0BAA0B;AAC9B;AACA;IACI,WAAW;AACf;AACA;IACI,eAAe;IACf,eAAe;AACnB;AACA;IACI,iBAAiB;AACrB;;AAEA,SAAS;AACT;IACI,cAAc;IACd,mBAAmB;AACvB;AACA;IACI,sBAAsB;IACtB,aAAa;IACb,iBAAiB;AACrB;AACA;IACI,2BAA2B;IAC3B,aAAa;AACjB;AACA;IACI,sBAAsB;IACtB,WAAW;IACX,cAAc;IACd,SAAS;IACT,6BAA6B;AACjC;AACA;IACI,sBAAsB;IACtB,WAAW;IACX,cAAc;IACd,SAAS;IACT,6BAA6B;IAC7B,aAAa;AACjB;AACA;wFACwF;AACxF;IACI,uCAAuC;IACvC,mCAAmC;AACvC;AACA;;IAEI,SAAS;IACT,gBAAgB;IAChB,sBAAsB;IACtB,WAAW;AACf;AACA;IACI,WAAW;AACf;AACA,yDAAyD;AACzD;IACI,6BAA6B;AACjC;AACA;IACI,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,WAAW;AACf;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,oBAAoB;AACxB;AACA;IACI,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,WAAW;AACf;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;IACX,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,kBAAkB;IAClB,WAAW;AACf;AACA;IACI,sBAAsB;IACtB,WAAW;IACX,cAAc;IACd,SAAS;IACT,6BAA6B;IAC7B,aAAa;AACjB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,OAAO;IACP,QAAQ;IACR,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,eAAe;AACnB;AACA;IACI,sBAAsB;AAC1B;AACA,oBAAoB;AACpB;IACI,aAAa;IACb,sBAAsB,EAAE,2BAA2B;IACnD,QAAQ,gBAAgB,+BAA+B;IACvD,WAAW;IACX,sBAAsB;AAC1B;;AAEA,sBAAsB;AACtB;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;IACX,sBAAsB;IACtB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB,EAAE,0BAA0B;AACrD;;AAEA,uBAAuB;AACvB;IACI,WAAW;IACX,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA,kBAAkB;AAClB;IACI,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,2BAA2B;IAC3B,QAAQ,EAAE,uBAAuB;AACrC;;AAEA,gBAAgB;AAChB;IACI,yBAAyB;AAC7B;;AAEA,eAAe;AACf;IACI,UAAU;IACV,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA,4DAA4D;AAC5D;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA,+BAA+B;AAC/B;IACI,+DAA+D;IAC/D,wBAAwB;IACxB,gCAAgC;IAChC,YAAY;IACZ,gBAAgB,EAAE,qDAAqD;AAC3E;AACA;IACI,kDAAkD;IAClD,2BAA2B;IAC3B,oBAAoB;IACpB,wCAAwC;AAC5C;AACA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,kBAAkB;;IAElB,eAAe;IACf,6EAA6E;IAC7E,wBAAwB;IACxB,gCAAgC;AACpC;AACA;IACI,cAAc;IACd,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,UAAU;AACd;;;;AAIA;IACI,aAAa;AACjB;;;AAGA,SAAS;AACT;IACI,mBAAmB;AACvB;AACA;IACI,qBAAqB;IACrB,eAAe;AACnB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,qBAAqB;AACzB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,sBAAsB;AAC1B;;AAEA,mBAAmB;AACnB;IACI,cAAc;IACd,wBAAwB;IACxB,WAAW;AACf;AACA;IACI,SAAS;IACT,UAAU;AACd;AACA;IACI,mBAAmB;IACnB,cAAc;IACd,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA,IAAI;AACJ;IACI,gBAAgB;AACpB","sourcesContent":[".feature-details {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n}\n\n/* tabs: a grid of buttons separated by white lines, every row is filled completely */\n.feature-details div.ButtonBar {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 2px;\n    padding: 2px 0;\n    margin: 0;\n    border: 0;\n    background-color: #fff;\n}\n.feature-details div.ButtonBar div.buttonbar-button-container {\n    flex: 1 1 auto;\n    display: flex;\n    border: 0;\n    margin: 0;\n}\n.feature-details div.ButtonBar div.buttonbar-button-container > button.button {\n    flex: 1 1 auto;\n    border: 0;\n    border-radius: 0;\n    padding: 0.7em 1em;\n    white-space: nowrap;\n    background-color: #d3d6d5;\n    color: #323232;\n    transition: background-color 0.15s;\n}\n.feature-details div.ButtonBar button span {\n    padding: 0;\n    margin: 0;\n}\n.feature-details div.ButtonBar button.button:not(:disabled):not(.pressed):hover {\n    background-color: #bfc3c2;\n}\n.feature-details div.ButtonBar button.button.pressed:not(:disabled) {\n    background-color: #078aa3;\n    color: white;\n    font-weight: bold;\n    box-shadow: inset 0 -3px 0 #05566a;\n}\n\n.feature-link {\n    cursor: pointer;\n    color: #337ab7;\n}\n\n.feature-details {\n    font-size: .9em;\n}\n.feature-details-tabs {\n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;\n}\n.feature-details-tab {\n    padding: 0.5em;\n    flex-grow: 1;\n}\n.feature-details-tab .attribute-list {\n    width: 100%;\n    border-collapse: collapse;\n}\n.feature-details-tab .attribute-list td {\n    vertical-align: top;\n    border-bottom: 1px solid #e6e9e8;\n    padding: .35rem .5rem;\n}\n.feature-details-tab .attribute-list tr:last-child td {\n    border-bottom: 0;\n}\n.feature-details-tab .attribute-list td:first-child {\n    padding-right: 1rem;\n    color: #6b7070;\n    white-space: nowrap;\n}\n.feature-details-tab .attribute-list tr:hover td {\n    background-color: #e6f1f3;\n}\n\n.feature-details-ajax > div {\n    text-align: center;\n}\n.feature-details-ajax .spinner {\n    text-align: center;\n    margin: 0 auto;\n    width: 50px;\n    height: 50px;\n}\n\n/* breadcrumb */\n.feature-breadcrumb {\n    padding: .4em .75em;\n    margin: 0;\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    background-color: #eceeee;\n    border-bottom: 1px solid #d3d6d5;\n}\n.feature-breadcrumb li {\n    margin: 0 .35em 0 0;\n    padding: 0;\n    list-style-type: none;\n    font-size: .85rem;\n    color: #323232;\n}\n.feature-breadcrumb li:last-child {\n    font-weight: bold;\n}\n.feature-breadcrumb  .icon {\n    font-size: .65rem;\n    color: #8a8f8e;\n    margin-right: .1em;\n}\n.feature-breadcrumb li:first-child .icon {\n    display: none;\n}\n.feature-breadcrumb li .link {\n    cursor: pointer;\n    color: #078aa3;\n}\n.feature-breadcrumb li .link:hover {\n    text-decoration: underline;\n    color: #05566a;\n}\n\n/* ajax table */\n.feature-ajax-table {\n    width: 100%;\n    border-collapse: collapse;\n}\n.feature-ajax-table .actions .icon {\n    cursor: pointer;\n    color: #078aa3;\n}\n.feature-ajax-table .actions .icon:hover {\n    color: #05566a;\n}\n.feature-ajax-table .interactive:hover {\n    background-color: #eeeeee;\n}\n.feature-ajax-table .actions span {\n    margin-left: 6px;\n}\n.feature-ajax-table thead th {\n    color: #323232;\n    text-align: left;\n    font-weight: bold;\n    padding: 6px 8px;\n    background-color: #eceeee;\n    border-bottom: 2px solid #afb3b2;\n    position: sticky;\n    top: 0;\n}\n.feature-ajax-table tbody tr:nth-child(even) {\n    background-color: #f2f4f4;\n}\n.feature-ajax-table tbody tr:hover {\n    background-color: #dcecef;\n}\n.feature-ajax-table tbody tr:hover td {\n    border-color: #fff;\n}\n.feature-ajax-table tbody td {\n    padding: 5px 8px;\n}\n.feature-ajax-table tbody td {\n    border-right: 1px solid #dcdfde;\n}\n.feature-ajax-table tbody td:last-child {\n    border-right: 0;\n}\n.feature-ajax-table .actions {\n    white-space: nowrap;\n}\n\n/* download */\n.feature-details-ajax-download {\n    text-align: right;\n}\n\n/* image */\n.feature-details-image img {\n    width: 100%;\n}\n.feature-details-image-options {\n    padding: 5px 10px 10px;\n    display: flex;\n    flex-wrap: wrap;\n}\n.feature-details-image-options label {\n    display: inline-block;\n    margin-right: 15px;\n    margin-bottom: 3px;\n}\n.feature-details-image-options input {\n    margin-right: 5px;\n}\n\n/* ajax gallery */\n.feature-details-ajaxgallery-images {\n    display: flex;\n    align-items: stretch;\n    justify-content: left;\n    flex-wrap: wrap;\n}\n.feature-details-ajaxgallery-images > div {\n    text-align: center;\n    border: 1px solid #bbb;\n    margin-right: 10px;\n    margin-bottom: 10px;\n}\n\n/* ajax slider */\n.feature-details-ajaxslider {\n    text-align: center;\n}\n.feature-details-ajaxslider-image {\n    border: 1px solid #bbb;\n    padding: 5px;\n}\n.feature-details-ajaxslider-nav {\n    display: flex;\n    align-items: center;\n    gap: .5rem;\n    margin-top: .5rem;\n    justify-content: space-between;\n}\n.feature-details-ajaxslider-nav .nav-imgs {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: .5rem\n}\n.feature-details-ajaxslider-nav .nav-imgs > * {\n    flex-basis: 120px;\n    flex-shrink: 1;\n}\n.feature-details-ajaxslider-nav img {\n    width: 100%;\n}\n.feature-details-ajaxslider-nav .caption {\n    word-break: break-all;\n    font-size: 11px;\n}\n.feature-details-ajaxslider-nav .nav-img {\n    padding: 5px;\n    border: 1px solid #bbb;\n    cursor: pointer;\n}\n.feature-details-ajaxslider-nav .nav-left {\n    padding: 5px;\n    border: 1px solid #bbb;\n    cursor: pointer;\n}\n.feature-details-ajaxslider-nav .nav-left i {\n    font-size: 20px;\n    vertical-align: middle;\n}\n.feature-details-ajaxslider-nav .nav-right {\n    padding: 5px;\n    border: 1px solid #bbb;\n    cursor: pointer;\n}\n.feature-details-ajaxslider-nav .nav-right i {\n    font-size: 20px;\n    vertical-align: middle;\n}\n\n/* linklist */\n.feature-details-linklist table span {\n    cursor: pointer;\n    text-decoration: underline;\n}\n.feature-details-linklist table {\n    width: 100%;\n}\n.feature-details-linklist table img {\n    cursor: pointer;\n    max-width: 100%;\n}\n.feature-details-linklist table td:last-child {\n    text-align: right;\n}\n\n/* form */\n.feature-details-field {\n    display: block;\n    margin-bottom: 10px;\n}\n.feature-details-input {\n    border: 1px solid #bbb;\n    display: flex;\n    margin-right: 1em;\n}\n.feature-details-addon {\n    border-left: 1px solid #bbb;\n    padding: .3em;\n}\n.feature-details-field input[type=\"text\"], .feature-details-field input[type=\"date\"], .feature-details-field input[type=\"number\"] {\n    box-sizing: border-box;\n    width: 100%;\n    display: block;\n    border: 0;\n    background-color: transparent;\n}\n.feature-details-field select {\n    box-sizing: border-box;\n    width: 100%;\n    display: block;\n    border: 0;\n    background-color: transparent;\n    padding: .3em;\n}\n/* The frame is drawn by the wrapper only. qwc2's default input style (border, background, height) has a higher\n   specificity than the rules above and would add a second border to every text field. */\ndiv.feature-details-field div.feature-details-input {\n    background-color: var(--input-bg-color);\n    border-radius: var(--border-radius);\n}\ndiv.feature-details-field div.feature-details-input input:not([type=\"checkbox\"]):not([type=\"radio\"]):not([type=\"range\"]):not([type=\"file\"]),\ndiv.feature-details-field div.feature-details-input textarea {\n    border: 0;\n    border-radius: 0;\n    box-sizing: border-box;\n    width: 100%;\n}\ndiv.feature-details-field div.feature-details-input select {\n    height: 2em;\n}\n/* the geometry row only holds a button, no input frame */\ndiv.feature-details-field div.feature-details-input.feature-details-geometry {\n    background-color: transparent;\n}\n.feature-details-field label {\n    display: block;\n    opacity: .8;\n    font-size: .85em;\n    margin-bottom: 2px;\n}\n.feature-details-required-marker {\n    color: #c00;\n}\n.feature-details-geometry {\n    display: flex;\n    align-items: center;\n    gap: .6em;\n    flex-wrap: wrap;\n    border: 0 !important;\n}\n.feature-details-geometry-status {\n    color: #c00;\n    font-size: .85em;\n}\n.feature-details-geometry-hint {\n    font-size: .85em;\n    opacity: .8;\n}\n.feature-details-autocomplete {\n    width: 100%;\n}\n.feature-details-autocomplete-selected {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n    padding: .3em;\n    box-sizing: border-box;\n}\n.feature-details-autocomplete-search {\n    position: relative;\n    width: 100%;\n}\n.feature-details-autocomplete-search input[type=\"text\"] {\n    box-sizing: border-box;\n    width: 100%;\n    display: block;\n    border: 0;\n    background-color: transparent;\n    padding: .3em;\n}\n.feature-details-autocomplete-results {\n    position: absolute;\n    z-index: 10;\n    left: 0;\n    right: 0;\n    margin: 0;\n    padding: 0;\n    list-style: none;\n    background: #fff;\n    border: 1px solid #bbb;\n    max-height: 12em;\n    overflow-y: auto;\n}\n.feature-details-autocomplete-results li {\n    padding: .3em;\n    cursor: pointer;\n}\n.feature-details-autocomplete-results li:hover {\n    background-color: #eee;\n}\n/* === Upload  === */\n.feature-details-documents-upload-progresses {\n    display: flex;\n    flex-direction: column; /* stack items vertically */\n    gap: 8px;               /* space between upload items */\n    width: 100%;\n    box-sizing: border-box;\n}\n\n/* Individual Upload */\n.feature-details-documents-upload-progress {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    width: 100%;\n    box-sizing: border-box;\n    margin-bottom: 8px;\n    font-family: inherit;\n}\n\n.feature-details-documents-upload-progress > div:first-child {\n    font-weight: 600;\n    margin-bottom: 4px;\n    word-break: break-all; /* handle long filenames */\n}\n\n/* Progress container */\n.feature-details-documents-upload-progress-bar {\n    width: 100%;\n    background-color: #eee;\n    border-radius: 3px;\n    height: 8px;\n    position: relative;\n    overflow: hidden;\n    box-sizing: border-box;\n}\n\n/* Progress fill */\n.feature-details-documents-upload-progress-fill {\n    height: 100%;\n    background-color: #5cb85c;\n    border-radius: 3px;\n    transition: width 0.2s ease;\n    width: 0; /* default safe value */\n}\n\n/* Error state */\n.feature-details-documents-upload-progress-fill.error {\n    background-color: #d9534f;\n}\n\n/* Error text */\n.feature-details-documents-upload-error {\n    color: red;\n    font-weight: 600;\n    margin-top: 4px;\n    font-size: 0.9em;\n    word-break: break-word;\n}\n\n/* Ajax table overflow (scrollable to the right if needed) */\n.feature-details-fileupload .feature-details-ajax > div {\n    overflow-x: scroll;\n    max-width: 100%;\n}\n\n/* Drag hover visual feedback */\n.feature-details-fileupload {\n    transition-property: background-color, background-color, filter;\n    transition-duration: .2s;\n    transition-timing-function: ease;\n    padding: 1em;\n    min-height: 100%; /* make sure drag-n-drop area fits the full window. */\n}\n.feature-details-fileupload.drag-hover {\n    /* outline instead of border to keep size stable */\n    outline: 2px dashed #4caf50;\n    outline-offset: -2px;\n    background-color: rgba(76, 175, 80, 0.3);\n}\n.feature-details-fileupload .upload-drop-area {\n    border: 2px dashed #ccc;\n    border-radius: 6px;\n    padding: 20px;\n    text-align: center;\n    color: #666;\n    margin-bottom: 1em;\n\n    cursor: pointer;\n    transition-property: transform, color, border-color, background-color, filter;\n    transition-duration: .2s;\n    transition-timing-function: ease;\n}\n.feature-details-fileupload.drag-hover .upload-drop-area {\n    color: #4caf50;\n    border-color: #4caf50;\n    background: white;\n}\n\n.feature-details-fileupload .feature-details-input {\n    padding: 0;\n}\n\n\n\n.display-none {\n    display: none;\n}\n\n\n/* pois */\n.feature-details-poi {\n    margin-bottom: 1rem;\n}\n.feature-details-poi h5 {\n    margin: .3rem 0 .5rem;\n    font-size: 1rem;\n}\n.feature-details-poi .poi-item {\n    display: flex;\n    align-items: center;\n    justify-content: left;\n}\n.feature-details-poi .poi-item img {\n    margin-right: 5px;\n}\n.feature-details-poi .poi-item span {\n    margin-right: 5px;\n}\n.feature-details-poi .poi-item strong {\n    margin-left: auto;\n}\n.feature-details-poi .poi-item:nth-child(odd) {\n    background-color: #eee;\n}\n\n/* add components */\n.feature-details-component-add input {\n    display: block;\n    padding: .5em !important;\n    width: 100%;\n}\n.feature-details-component-add ul {\n    margin: 0;\n    padding: 0;\n}\n.feature-details-component-add li {\n    margin: .3rem 0 0 0;\n    padding: .5rem;\n    background-color: #eee;\n    cursor: pointer;\n}\n\n.feature-details-component-attachments div div {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n}\n\n/* */\n.feature-details-component-subs div.mt-3 {\n    margin-top: 2rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
